@if (groupesTech) {
  <div class="row pt-2">
    <div class="col-5">
      <div class="row">
        <div class="col-12">
          <input-gala [value]="getMulcln()" label="MULCLN" [disabled]="true" />
        </div>
      </div>
      <!-- GROUPES TECHNIQUES -->
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-9">{{lgTrad.GRPTECHNIQUES}}</div>
            <div class="col-md-3 text-right">
              <search-button class="pr-2 tab-btn-roundadd" (click)="openHistoGrpTechniques()" />
              @if (droitsAccess.write) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openGrpTechniques()"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr>
            <th>{{lgTrad.NOM}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (grp of groupesTech.GROUPESTECH; track grp) {
            <tr>
              <ng-container>
                <td>{{grp.RFGROUPE.GROUPE}}</td>
                <td>
                  <div class="btn-group w-100 justify-content-end">
                    @if (grp.FAVORI === 1) {
                      <button type="button" class="button-fav mr-1">
                        <i class="fas fa-star"></i>
                      </button>
                    }
                    @if (grp.FAVORI === 0) {
                      <button type="button" title="Passer le groupe en favori"
                        [disabled]="!droitsAccess.write" class="button-fav mr-1" (click)="askFavorite(grp)">
                        <i class="far fa-star"></i>
                      </button>
                    }
                    @if (droitsAccess.write && groupesTech.GROUPESTECH.length > 1) {
                      <gala-btn-delete
                        (click)="deleteGrpTechnique(grp)">
                        <i class="fas fa-trash-alt"></i>
                      </gala-btn-delete>
                    }
                  </div>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}